export default {
  schoolPlan: 'Encontraremos un plan para tu escuela',
  setNumber: 'Indícanos un número telefónico para que un Asesor Comercial pueda contarte acerca de la licencia {license}',
  phoneNumber: 'Teléfono',
  errorQuote: 'No se pudo pedir la cotización. Intente nuevamente más tarde',
  send: 'Enviar',
  thanksInterest: '¡Gracias por tu interés!',
  weWillContact: 'Te contactaremos a la brevedad.',
  byProgram: 'por programa',
  campus: 'campus'
}

export const en = {
  schoolPlan: 'We\'ll find a plan for your school',
  setNumber: 'Please give us a phone number so a Sales Rep reaches you about {license}',
  phoneNumber: 'Telephone',
  errorQuote: 'Failed to request quote. Please try again later.',
  send: 'Send',
  thanksInterest: 'Thank you for your interest!',
  weWillContact: 'We\'ll reach you soon.',
  byProgram: 'by program license',
  campus: 'campus license'
}

export const ca = {
  schoolPlan: 'Trobarem un pla per a la teva escola',
  setNumber: 'Indica\'ns un número de telèfon perquè un Assessor Comercial pugui explicar-vos sobre els plans que tenim disponibles {license}.',
  phoneNumber: 'Telèfon',
  errorQuote: 'No s\'ha pogut demanar la cotització. Prova-ho una altra vegada més tard',
  send: 'Envia',
  thanksInterest: 'Gràcies pel teu interès!',
  weWillContact: 'Ens posarem en contacte amb tu ben aviat..',
  byProgram: 'per programa',
  campus: 'campus'
}
